// Sportgramme
import React, { useEffect, useState, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
// Use the exact name from your SEC_01_02_coreAuthClient.js file
import { coreAuthClient } from "../pre/SEC_01_02_coreAuthClient"; 

const VerifyEmailPage = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [status, setStatus] = useState("Verifying your account...");
    const hasRun = useRef(false); // 🔒 Prevents double execution

    const token = searchParams.get("token");

    useEffect(() => {
        // 🚫 React 18 StrictMode runs useEffect twice in dev — this guard stops the second call
        if (hasRun.current) return;
        hasRun.current = true;

        if (!token) {
            setStatus("No verification token found.");
            return;
        }

        const runVerification = async () => {
            try {
                // STRATEGY: Use the pre-built client instead of raw fetch
                // This method handles the SITE-KEY and BASE_URL automatically
                const result = await coreAuthClient.verifyEmail({ verificationToken: token });

                if (result.ok) {
                    setStatus("Email verified successfully! Redirecting to sign-in...");
                    setTimeout(() => navigate("/auth/sign-in"), 3000);
                } else {
                    // Pull the error message directly from your client's response
                    setStatus(result.message || "Verification failed. Link may be expired.");
                }
            } catch (err) {
                setStatus("A system error occurred while verifying your account.");
            }
        };

        runVerification();
    }, [token, navigate]);

    return (
        <main id="main" className="page-main registered-page" data-scroll-container>
            <div className="page-main-inner">
                <section className="page-section">
                    <div className="page-section__body d-flex justify-content-center">
                        <div style={{ width: "100%", maxWidth: "550px" }} className="text-center">
                            <h2 className="h4 fw-bold mb-3">Account Verification</h2>
                            <p className="text-muted">{status}</p>
                        </div>
                    </div>
                </section>
            </div>
        </main>
    );
};

export default VerifyEmailPage;
